import * as e from "react";
import { WmkLink as t } from "wmk-link";
import { GrFacebook as l, GrTwitter as n, GrLinkedin as r, GrYoutube as a, GrInstagram as o, GrPinterest as i, GrMedium as c, GrReddit as m, GrSnapchat as u, GrSpotify as s, GrTumblr as f, GrVimeo as E } from "react-icons/gr";
import { FaYelp as d, FaTiktok as p, FaBehance as v, FaFlickr as k, FaHouzz as y } from "react-icons/fa";

var g = e.forwardRef(function (l, n) {
  var r = l.platform,
      a = l.url,
      o = l.target,
      i = void 0 === o ? "blank" : o,
      c = l.className,
      m = void 0 === c ? "" : c,
      u = r.Icon,
      s = r.name,
      f = s + ("" !== m ? " " + m : "");
  return e.createElement(t, {
    key: s,
    to: a,
    target: i,
    className: f,
    ref: n,
    title: "Visit " + s + " page"
  }, u, e.createElement("span", {
    className: "sr-only sr-only-focusable visually-hidden visually-hidden-focusable"
  }, "Visit " + s + " page"));
}),
    b = {
  facebook: e.createElement(l, null),
  twitter: e.createElement(n, null),
  linkedin: e.createElement(r, null),
  youtube: e.createElement(a, null),
  instagram: e.createElement(o, null),
  pinterest: e.createElement(i, null),
  yelp: e.createElement(d, null),
  medium: e.createElement(c, null),
  reddit: e.createElement(m, null),
  snapchat: e.createElement(u, null),
  spotify: e.createElement(s, null),
  tumblr: e.createElement(f, null),
  vimeo: e.createElement(E, null),
  tiktok: e.createElement(p, null),
  behance: e.createElement(v, null),
  flickr: e.createElement(k, null),
  houzz: e.createElement(y, null)
},
    N = function N(t) {
  var l,
      n,
      r,
      a = t.socials,
      o = t.platforms,
      i = void 0 === o ? b : o,
      c = t.className,
      m = (void 0 === (n = void 0 === c ? "" : c) && (n = ""), void 0 === r && (r = "wmk"), [r + "-" + (l = "social"), r + "-" + l + "-" + "icon", n].join(" ").trim());
  return e.createElement("div", null, a.map(function (t) {
    var l = t.title,
        n = t.url,
        r = t.target,
        a = function (t) {
      var l = t.toLocaleLowerCase();
      return l in i ? i[l] : e.createElement("div", null, "Error: No Icon in platform definition for ", l);
    }(l);

    return e.createElement(g, {
      platform: {
        name: l,
        Icon: a
      },
      url: n,
      target: r,
      className: m,
      key: l + "-icon"
    });
  }));
};

export { N as SocialMediaIcons, b as defaultPlatforms };